<template>
    <!-- 左右に矢印ボタンの付いたラベル -->
    <div style="display: flex; font-size: 1.1rem">
        <button class="arrow-button" :disabled="disabled" @click="$emit('click', -1)">
            <svg yu-icon="ku-left" y="-5" size="20"></svg>
        </button>
        <slot></slot>
        <button class="arrow-button" :disabled="disabled" @click="$emit('click', 1)">
            <svg yu-icon="ku-right" y="-5" size="20"></svg>
        </button>
    </div>
</template>


<script>
export default {
    props: {
        disabled: Boolean,
    },
}
</script>

<style scoped>
.arrow-button{
    display: flex;
    align-items: center;
    border: none;
    background: none;
    color: gray;
}
.arrow-button:active{
    color: dimgray;
}
.arrow-button:disabled{
    color: darkgray;
}
</style>